import CONFIG from '../../Config';

export const API = {
  // QUESTIONNAIRE V2
  questionnaire: {
    FETCH__ALL: () => '/api/v2/questionnaires',
    FETCH__BY_ID: id => `/api/v2/questionnaires/${id}`,
    ACTION__COMPUTE: () => `/api/v2/questionnaires/actions/compute`,
  },
  // SALESROUTE V2
  salesroute: {
    FETCH__ALL: (limit = CONFIG.fetchAllLimit) => `/api/v2/sales-route?limit=${limit}`, // default limit to 100 items
    FETCH__BY_ID: id => `/api/v2/sales-route/${id}`,
    CREATE: () => '/api/v2/sales-route',
    UPDATE__BY_ID: id => `/api/v2/sales-route/${id}`,
    PATCH__BY_ID: id => `/api/v2/sales-route/${id}`,
    ACTION__CREATE_SALESROUTE: () => `/api/v2/sales-route/actions/create-salesroute`,
    ACTION__COMPUTE_QUESTIONNAIRE__BY_ID: id => `/api/v2/sales-route/${id}/actions/compute-questionnaires`,
    ACTION__DESCRIBE_QUOTATION__BY_ID: id => `/api/v2/sales-route/${id}/actions/describe-quotation`,
    ACTION__GENERATE_CONTRACTS__BY_ID: id => `/api/v2/sales-route/${id}/actions/generate-contracts`,
    ACTION__SIMULATE_CONTRACTS__BY_ID: id => `/api/v2/sales-route/${id}/actions/simulate-contracts`,
    ACTION__SIMULATE_QUOTATIONS__BY_ID: id => `/api/v2/sales-route/${id}/actions/simulate-quotations`,
    ACTION__PRINT_SALESROUTE__BY_ID: id => `/api/v2/sales-route/${id}/actions/print-sales-route`,
    ACTION__SYNCHRONIZE_SALESFORCE__BY_ID: id => `/api/v2/sales-route/${id}/actions/synchronize-salesforce`,
    ACTION__SUBSCRIBE_CONTRACTS_BY_ID: id => `/api/v2/sales-route/${id}/actions/subscribe-contracts`,
    ACTION__DUPLICATE: id => `/api/v2/sales-route/${id}/actions/duplicate`,
    ACTION__DUPLICATE_QUOTE: id => `/api/v2/sales-route/${id}/actions/duplicate-quote`,
  },
};
